import { useCallback, useRef } from 'react'

export default function useLongPress(onLongPress: () => void, delay = 500) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const didLongPressRef = useRef(false)

  const onTouchStart = useCallback(() => {
    didLongPressRef.current = false
    timerRef.current = setTimeout(() => {
      didLongPressRef.current = true
      onLongPress()
    }, delay)
  }, [onLongPress, delay])

  const cancel = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }, [])

  const onTouchEnd = useCallback(() => {
    cancel()
  }, [cancel])

  const onTouchMove = useCallback(() => {
    cancel()
  }, [cancel])

  return { handlers: { onTouchStart, onTouchEnd, onTouchMove }, didLongPress: didLongPressRef }
}
